import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand from './CategoryCommand';

class ToolbarCommand extends CategoryCommand<void> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.TOOLBAR,
    };
  }

  public getIcon(): IconName {
    return 'tools';
  }
}

export default ToolbarCommand;
